import { createStore } from 'vuex'

import utils from '../js/utils.js'
import api from '../js/api.js'


export default createStore({
  state: {
    globalUrl: 'https://app.xiangmaitech.cn',
    requestType: 'java',  //后台语言 php、java
    // token:localStorage.getItem('token') ? localStorage.getItem('token'):'',
    token: utils.getLocal('token'),
    info: utils.getLocal('info','json'),
    menuList: utils.getLocal('menuList','json'),
    routeCurrent: utils.getLocal('routeCurrent'),
    allowedUrls: utils.getLocal('allowedUrls','json') || [],  // 当前角色允许访问的路由路径
    _lastRefresh: 0,  // 上次权限刷新时间戳，用于节流
  },
  getters: {
  },
  mutations: {
    setToken(state, value) { // 设置存储token
			state.token = value;
			localStorage.setItem('token', value);
		},
    setInfo(state, value) { // 设置存储账户详情
			state.info = value;
			localStorage.setItem('info', JSON.stringify(value));
		},
    setMenuList(state, value) { // 设置存储侧栏数据
			state.menuList = value;
			localStorage.setItem('menuList', JSON.stringify(value));
		},
    setRouteCurrent(state, value) { // 设置存储路由路径
			state.routeCurrent = value;
			localStorage.setItem('routeCurrent', value);
		},
    setAllowedUrls(state, value) { // 设置允许访问的路由路径（权限控制）
			state.allowedUrls = value;
			localStorage.setItem('allowedUrls', JSON.stringify(value));
		},
   
  },
  actions: {
    // 实时刷新权限：拉取最新权限ID + 菜单树，重建 menuList 和 allowedUrls
    // 带 5 秒节流（仅对非超管），避免频繁导航时重复请求
    async refreshPermissions({ commit, state }) {
      const info = state.info || {};
      const isSuperAdmin = info.roleId === 1;

      if (!isSuperAdmin) {
        const now = Date.now();
        if (now - state._lastRefresh < 5000) return; // 5 秒节流
        state._lastRefresh = now;
      }

      try {
        // 超管：只拉菜单树，不过滤；其他角色：并发拉权限 + 菜单树
        const [permIds, menuData] = isSuperAdmin
          ? [null, await api.getMenuTree()]
          : await Promise.all([
              api.getBindingPermission({ id: info.roleId }),
              api.getMenuTree(),
            ]);

        // 按最新权限ID过滤菜单树（超管不过滤）
        let filteredMenu = menuData || [];
        if (!isSuperAdmin && permIds && permIds.length > 0) {
          filteredMenu = filteredMenu
            .filter(item => permIds.includes(item.menuId))
            .map(parent => ({
              ...parent,
              children: (parent.children || []).filter(c => permIds.includes(c.menuId)),
            }));
        }

        // 从菜单树递归收集所有路由路径
        const allowedUrls = new Set();
        const collectUrls = (items) => {
          (items || []).forEach(item => {
            if (item.url) allowedUrls.add(item.url);
            if (item.children && item.children.length > 0) collectUrls(item.children);
          });
        };
        collectUrls(filteredMenu);

        // 子页面映射（不在菜单树中但属于下级页面）
        const subPageMap = {
          '/partnerHistory': '/partnerData',
          '/knowledgeAdd': '/knowledgeL',
          '/userInfo': '/users',
          '/deviceInfo': '/device',
          '/channelInfo': '/channel',
          '/deviceOrderInfo': '/deviceOrder',
          '/orderReportInfo': '/orderReport',
          '/financeInfo': '/finance',
          '/guideAdd': '/guideL',
          '/informationAdd': '/informationL',
          '/onlineCardInfo': '/onlineCard',
          '/offlineCardInfo': '/offlineCard',
          '/offlineCardAdd': '/offlineCard',
          '/issue': '/systemNews',
          '/articleEdit': '/article',
        };
        Object.entries(subPageMap).forEach(([sub, parent]) => {
          if (allowedUrls.has(parent)) allowedUrls.add(sub);
        });

        commit('setAllowedUrls', [...allowedUrls]);
        commit('setMenuList', filteredMenu);
      } catch (e) {
        // 刷新失败时保持现有状态，不阻断导航
        console.warn('权限刷新失败，使用缓存数据', e);
      }
    },
  },
  modules: {
  }
})
